import { Box, SvgIcon, Typography } from "@mui/material"
import { ReactComponent as MediumIcon } from "static/svg/alerts/medium.svg"

const WarningCard = ({ item, size }) => {
  return (
    <Box>
      <Box
        sx={{
          display: "inline-flex",
          alignContent: "center",
          p: size === "normal" ? 1 : 0.5,
          backgroundColor: "#FFFFCF",
          borderRadius: "8px",
        }}
      >
        <Typography variant={size === "normal" ? "body2" : "caption"} sx={{ fontWeight: 500 }}>
          {item.name}
        </Typography>
        {size === "normal" && (
          <SvgIcon component={MediumIcon} inheritViewBox sx={{ ml: 1, width: 18, height: 18 }} />
        )}
      </Box>
    </Box>
  )
}

export default WarningCard
